import { render, staticRenderFns } from "./T1Regulamin.vue?vue&type=template&id=19f7c170&scoped=true&"
var script = {}
import style0 from "./T1Regulamin.vue?vue&type=style&index=0&id=19f7c170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f7c170",
  null
  
)

export default component.exports